import React from "react";
import { SvgIcon } from "@mui/material";
import socialLinkIconStyles from "../../icons/socialLinkIconStyles";

const LinkedinLogoIcon = ({ color }: any) => {
  return (
    <SvgIcon sx={socialLinkIconStyles(color)}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 13.1305V16.8275H14.857V13.3775C14.857 12.5115 14.547 11.9205 13.771 11.9205C13.179 11.9205 12.826 12.3185 12.671 12.7045C12.615 12.8425 12.6 13.0345 12.6 13.2265V16.8275H10.456C10.456 16.8275 10.485 10.9855 10.456 10.3805H12.6V11.2935L12.586 11.3145H12.6V11.2935C12.885 10.8535 13.393 10.2285 14.532 10.2285C15.942 10.2285 17 11.1505 17 13.1305ZM8.213 7.27148C7.48 7.27148 7 7.75348 7 8.38548C7 9.00548 7.466 9.50048 8.185 9.50048H8.199C8.947 9.50048 9.412 9.00448 9.412 8.38548C9.398 7.75348 8.947 7.27148 8.213 7.27148ZM7.127 16.8275H9.271V10.3805H7.127V16.8275Z"
        />
        <path
          d="M12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default LinkedinLogoIcon;